import { reaction } from "mobx"
import { addDisposer, flow, types } from "mobx-state-tree"
import { AuthService } from "resources"
// import { store } from "../app/store"

const User = types.model("User", {
  id: types.maybe(types.number),
  images: types.maybeNull(types.array(types.string)),
  name: types.optional(types.string, ""),
  surname: types.maybeNull(types.string, ""),
  phone: types.maybe(types.string),
  salonId: types.maybeNull(types.number),
  // step: types.maybe(types.string), // Add step field to user model
})

export const AuthStore = types
  .model("AutoStore", {
    accessToken: types.optional(types.string, ""),
    refreshToken: types.optional(types.string, ""),
    user: types.maybeNull(User),
    role: types.maybe(types.string), // @DEBUG role maybe exists in userObject
    checkingIsAuth: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    loadData: flow(function* ({ phone, password }) {
      try {
        self.checkingIsAuth = true
        const response = yield AuthService.login({ phone, password })
        if (response.status === 401) {
          self.accessToken = ""
          self.refreshToken = ""
          // Clear localStorage on 401 to prevent token issues
          localStorage.removeItem("accessToken")
          localStorage.removeItem("refreshToken")
        }
        self.accessToken = response.data?.data?.accessToken
        self.refreshToken = response.data?.data?.refreshToken
        self.user = response.data?.data?.user
        self.role = response.data?.data?.role
        
        // Store tokens with consistent format
        if (self.accessToken) {
          localStorage.setItem("accessToken", self.accessToken)
        }
        if (self.refreshToken) {
          localStorage.setItem("refreshToken", self.refreshToken)
        }
        
        // Update Redux step when user logs in
        // if (response.data?.data?.user?.step) {
        //   store.dispatch({ type: 'StepSliceReducer/setStep', payload: response.data.data.user.step })
        // }
        
        self.checkingIsAuth = false
        return Promise.resolve(response)
      } catch (error) {
        self.checkingIsAuth = false
        self.user = null
        // Clear tokens on error
        localStorage.removeItem("accessToken")
        localStorage.removeItem("refreshToken")
        return Promise.reject(error)
      }
    }),
    setCredentials({ accessToken, refreshToken, user, role }) {
      self.accessToken = accessToken
      self.refreshToken = refreshToken
      self.user = user
      self.role = role
      
      // Update Redux step when credentials are set
      // if (user?.step) {
      //   store.dispatch({ type: 'StepSliceReducer/setStep', payload: user.step })
      // }
    },
    loadUserInfo: flow(function* () {
      // try {
      //   const response = yield AuthService.getUserInfo()
      //   localStorage.setItem("user", JSON.stringify(response?.data?.data?.user))
      //   const user = response.data?.data?.user
      //   self.user = { ...user, salonId: user.salon_id }
        
      //   // Update Redux step when user info is loaded
      //   // if (user?.step) {
      //   //   store.dispatch({ type: 'StepSliceReducer/setStep', payload: user.step })
      //   // }
      // } catch (error) {
      //   console.error("Failed to load user info:", error)
      //   // Clear auth data if we can't fetch user info
      //   self.clear()
      // }
    }),
    clear() {
      self.accessToken = ""
      self.user = null
      self.role = undefined
    },
  }))
  .actions((self) => ({
    afterCreate() {
      self.accessToken = localStorage.getItem("accessToken") ?? ""
      self.refreshToken = localStorage.getItem("refreshToken") ?? ""

      // Load user data from localStorage if available
      const userData = localStorage.getItem("user")
      if (userData) {
        try {
          const parsedUser = JSON.parse(userData)
          // Validate that the user object has required fields
          if (parsedUser && typeof parsedUser === 'object' && parsedUser.id) {
            self.user = parsedUser
          } else {
            console.warn("Invalid user data in localStorage, clearing...")
            localStorage.removeItem("user")
          }
        } catch (error) {
          console.error("Failed to parse user data from localStorage:", error)
          // Clear corrupted data
          localStorage.removeItem("user")
        }
      }

      if (self.accessToken.length > 0) {
        // Add a small delay to ensure the store is fully initialized
        // setTimeout(() => {
        //   self.loadUserInfo()
        // }, 100)
      }

      const accessTokenDisposer = reaction(
        () => self.accessToken,
        (token) => {
          if (!token?.length) {
            localStorage.removeItem("accessToken")
            return
          }

          // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
          // Проверяем, чтобы избежать дублирования "Bearer"
          const formattedToken = token.startsWith("Bearer ") 
            ? token 
            : `Bearer ${token}`
          localStorage.setItem("accessToken", formattedToken)
          // Add a small delay to ensure the token is properly set in localStorage
          // setTimeout(() => {
          //   self.loadUserInfo()
          // }, 100)
        }
      )
      const refreshTokenDisposer = reaction(
        () => self.refreshToken,
        (token) => {
          if (!token?.length) {
            localStorage.removeItem("refreshToken")
            return
          }
          localStorage.setItem("refreshToken", `Bearer ${token}`)
        }
      )

      addDisposer(self, accessTokenDisposer)
      addDisposer(self, refreshTokenDisposer)
    },
  }))